const falseValues = ['', undefined, null, false, 'false', NaN];

export const getSearchStringFormObject = (
  params: Record<string, string | number | boolean | undefined>[],
) => {
  try {
    if (!params) return '';
    const searchParams = new URLSearchParams();
    params.forEach((param) => {
      Object.entries(param).forEach(([key, value]) => {
        if (!falseValues.includes(value)) searchParams.append(key, value.toString());
      });
    });
    if (!searchParams.size) return '';
    return `?${searchParams.toString()}`;
  } catch (e) {
    return '';
  }
};
